import { render, staticRenderFns } from "./DecidedPhdThesis.vue?vue&type=template&id=2c8ea56c&"
import script from "./DecidedPhdThesis.vue?vue&type=script&lang=js&"
export * from "./DecidedPhdThesis.vue?vue&type=script&lang=js&"
import style0 from "./DecidedPhdThesis.vue?vue&type=style&index=0&id=2c8ea56c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports